import React, { useState, useEffect } from 'react';

import BlackFilterButton from "./text-tag";
import ColroChipButton from "./colorchip-tag";

export default props=>{
  const [vGender, setGender] = useState(props.gender);
  const [vSeason, setSeason] = useState(props.season);
  const [vColor , setColor ] = useState(props.color );

  useEffect(()=>{
    setGender(props.gender);
    setSeason(props.season);
    setColor (props.color );
  },[props]);

  return (<div className="black-filter">
    <style jsx>{`
.black-filter{

}

.content{
    width: 1290px;
    height: 55px;
    line-height: 55px;
    margin: 0 auto;
    text-align: right;

    background-color: #4a4a4a;
}

.button {
    display:inline;
    height: 24px;
    border-radius: 16px;
    border: solid 1px #adb5bd;
}




@media all and (max-width:606px) {
  .content{width: 100%;}
}


`}</style>

    <div className="content" style={{ display: (vGender == '전체' && vSeason == '전체' && vColor == '전체'?'none':'block')}}>

      {(!vGender // 값이 없으면 감추기
        ||vGender=='전체' // 전체면 감추기
        ?null:
        <BlackFilterButton tag={vGender} 
          remove={()=>{
            setGender('전체');
            props.setCommunityFilter && props.setCommunityFilter(
              { 'gender': '전체', 'season': vSeason, 'color': vColor }
            );
          }}
        />)}
      
      {(!vSeason
        ||vSeason=='전체'
        ?null:
        <BlackFilterButton tag={vSeason} 
          remove={() => {
            setSeason('전체');
            props.setCommunityFilter && props.setCommunityFilter(
              { 'gender': vGender, 'season': '전체', 'color': vColor }
            );
          }}
        />)}
      
      {(!vColor
        ||vColor=='전체'
        ?null:
        <ColroChipButton tag={vColor} 
          remove={() => {
            setColor('전체');
            props.setCommunityFilter && props.setCommunityFilter(
              { 'gender': vGender, 'season': vSeason, 'color': '전체' }
            );
          }}
        />)}
      
    </div>

  </div>);
}